import { Grid, Typography } from '@mui/material';
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import ChipInputField from '../../../mini-components/ChipInputField';

const BehaviorInputs = ({ control }) => {
  const [expectedBehaviourInput, setExpectedBehaviourInput] = useState('');
  const [unacceptableBehaviourInput, setUnacceptableBehaviourInput] = useState('');
  const [highlightInput, setHighlightInput] = useState('');

  return (
    <Grid item xs={12}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" gutterBottom sx={{ color: "#fff" }}>
            Expected Behaviours
          </Typography>
          <Controller
            name="expectedBehaviours"
            control={control}
            render={({ field }) => (
              <ChipInputField
                value={expectedBehaviourInput}
                setValue={setExpectedBehaviourInput}
                chips={field.value}
                setChips={(chips) => field.onChange(chips)}
                placeholder="Type Expected Behaviours"
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" gutterBottom sx={{ color: "#fff" }}>
            Unacceptable Behaviours
          </Typography>
          <Controller
            name="unacceptableBehaviours"
            control={control}
            render={({ field }) => (
              <ChipInputField
                value={unacceptableBehaviourInput}
                setValue={setUnacceptableBehaviourInput}
                chips={field.value}
                setChips={(chips) => field.onChange(chips)}
                placeholder="Type Unacceptable Behaviours"
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom sx={{ color: "#fff" }}>
            Highlights
          </Typography>
          <Controller
            name="highlights"
            control={control}
            render={({ field }) => (
              <ChipInputField
                value={highlightInput}
                setValue={setHighlightInput}
                chips={field.value}
                setChips={(chips) => field.onChange(chips)}
                placeholder="Type highlight"
              />
            )}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BehaviorInputs;
